export const DEACTIVATE_USER_LOADING = 'DEACTIVATE_USER_LOADING';
export const DEACTIVATE_USER_FAILED = 'DEACTIVATE_USER_FAILED';
export const DEACTIVATE_USER_SUCCESS = 'DEACTIVATE_USER_SUCCESS';
export const CLEAR_DEACTIVATE_USER = 'CLEAR_DEACTIVATE_USER';
